'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./white-labeling.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _whiteLabeling = require('hellosign/components/api/white-labeling');

var _whiteLabeling2 = _interopRequireDefault(_whiteLabeling);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
    _inherits(WhiteLabelingLandingPage, _React$Component);

    function WhiteLabelingLandingPage(props) {
        _classCallCheck(this, WhiteLabelingLandingPage);

        var _this = _possibleConstructorReturn(this, (WhiteLabelingLandingPage.__proto__ || Object.getPrototypeOf(WhiteLabelingLandingPage)).call(this, props));

        _this.state = {
            'contactUsModalIsShown': false
        };
        return _this;
    }

    _createClass(WhiteLabelingLandingPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var q = document.location.search;
            if (q && q.indexOf('aliId=') >= 0) {
                document.location.hash = '';
                this.closeContactUsModal();
            }

            this.timerId = setInterval(function () {
                var h = document.location.hash;
                if (h === '#contact-us') {
                    _this2.openContactUsModal();
                }
            }, 100);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.timerId);
        }
    }, {
        key: 'openContactUsModal',
        value: function openContactUsModal() {
            this.setState({
                'contactUsModalIsShown': true
            });
        }
    }, {
        key: 'closeContactUsModal',
        value: function closeContactUsModal() {
            this.setState({
                'contactUsModalIsShown': false
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var modalClassNames = (0, _classnames2['default'])({
                'm-white-labeling--contact-modal': true,
                'is-shown': this.state.contactUsModalIsShown === true
            });

            var contactUsModal = _react2['default'].createElement(
                'div',
                { className: modalClassNames },
                _react2['default'].createElement('div', { className: 'm-white-labeling--contact-modal--overlay' }),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-white-labeling--contact-modal--form' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-white-labeling--contact-modal--form--header' },
                        'Contact us'
                    ),
                    _react2['default'].createElement(
                        'a',
                        { href: '#',
                            onClick: this.closeContactUsModal.bind(this),
                            className: 'm-white-labeling--contact-modal--form--close' },
                        'x'
                    ),
                    _react2['default'].createElement(_marketoForm2['default'], { formId: 1139, trackingId: 'whitelabel-contactus' })
                )
            );

            return _react2['default'].createElement(
                'div',
                { className: 'm-white-labeling' },
                _react2['default'].createElement(
                    'header',
                    null,
                    _react2['default'].createElement(
                        'h1',
                        null,
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-white-labeling-try' },
                            'Try '
                        ),
                        'HelloSign\'s API White Labeling'
                    ),
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'Our signer page is customizable so it matches your color scheme exactly.'
                    ),
                    _react2['default'].createElement(
                        'a',
                        { href: '#contact-us' },
                        _react2['default'].createElement(
                            'button',
                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
                            'Contact Us'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'main',
                    null,
                    contactUsModal,
                    _react2['default'].createElement(_whiteLabeling2['default'], null),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-white-labeling-copy' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-white-labeling-bulb-computer' },
                            _react2['default'].createElement('img', {
                                src: require('../../assets/bulb_icon.png'),
                                'aria-hidden': true,
                                className: 'white-labeling-bulb-icon' }),
                            _react2['default'].createElement(
                                'span',
                                null,
                                'To try the interactive demo, please use your computer.'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-white-labeling-copy-text' },
                            _react2['default'].createElement(
                                'p',
                                null,
                                'We\'re dedicated to powering effortless document workflows from end-to-end. White labeling is just one feature empowering you to make your product or service easier for your users.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'HelloSign\'s white labeling feature allows API users to customize a signing flow with their branding, colors, and logo. That means your signers/users can seamlessly complete forms directly on your site. HelloSign is the only eSignature provider offering this level of flexibility in customization.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Connect with sales to learn more about adding this feature or explore the ',
                                _react2['default'].createElement(
                                    'a',
                                    { href: '/api/documentation' },
                                    'API documentation'
                                ),
                                '.'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-white-labeling-copy-cta' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'quote-and-documentation' },
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'quote-container' },
                                    _react2['default'].createElement(
                                        'h2',
                                        null,
                                        'Let\'s get you set up.'
                                    ),
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'get-a-quote', id: 'm-get-a-quote' },
                                        _react2['default'].createElement(
                                            'h3',
                                            null,
                                            _react2['default'].createElement(
                                                'span',
                                                { className: 'mobile-cta' },
                                                'SEE A DEMO'
                                            ),
                                            _react2['default'].createElement(
                                                'span',
                                                { className: 'regular-cta' },
                                                'GET A QUOTE'
                                            )
                                        ),
                                        _react2['default'].createElement(_marketoForm2['default'], { formId: 1157, trackingId: 'whitelabel-quote' })
                                    )
                                ),
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'documentation' },
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'see-documentation' },
                                        _react2['default'].createElement(
                                            'h3',
                                            null,
                                            'SEE DOCUMENTATION'
                                        ),
                                        _react2['default'].createElement(
                                            'button',
                                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
                                            _react2['default'].createElement(
                                                'a',
                                                { href: '/api/reference#WhiteLabeling' },
                                                'TAKE ME THERE'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return WhiteLabelingLandingPage;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/white-labeling.jsx
 ** module id = 1271
 ** module chunks = 0
 **/